// src/i18n/config.ts

// Core i18next library.
import i18n from 'i18next'
// Bindings for React: allow components to
// re-render when language changes.
import { initReactI18next } from 'react-i18next'

import en from './localization/en.json'
import es from './localization/es.json'
import ko from './localization/ko.json'
import zh from './localization/zh.json'

i18n
  // Add React bindings as a plugin.
  .use(initReactI18next)
  // Initialize the i18next instance.
  .init({
    // Config options

    // Specifies the default language (locale) used
    // when a user visits our site for the first time.
    // We use English here, but feel free to use
    // whichever locale you want.
    lng: 'en',

    // Fallback locale used when a translation is
    // missing in the active locale. Again, use your
    // preferred locale here.
    fallbackLng: 'en',

    // Enables useful output in the browser’s
    // dev console.
    debug: false,

    // Normally, we want `escapeValue: true` as it
    // ensures that i18next escapes any code in
    // translation messages, safeguarding against
    // XSS (cross-site scripting) attacks. However,
    // React does this escaping itself, so we turn
    // it off in i18next.
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      es: { translation: es },
      ko: { translation: ko },
      zh: { translation: zh },
    },
  })

export default i18n
